import { render } from "./AddPost.vue?vue&type=template&id=d41c1ba8"
import script from "./AddPost.vue?vue&type=script&lang=js"
export * from "./AddPost.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\OCL-APPLICATION-2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__